import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLineChart4"><Path fillRule="evenodd" clipRule="evenodd" d="M4 4V20H2V4H4ZM10 8V20H8V8H10ZM16 12V20H14V12H16ZM22 16V20H20V16H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart4;
